import { useQuery } from "@tanstack/react-query";
import { checkFeatureFlag, FeatureFlagName } from "api/featureFlag.api";

export const useIsFeatureFlagEnabled = (name: FeatureFlagName): boolean => {
  const { data } = useQuery(checkFeatureFlag(name));

  return data === true;
};
